import { Binder } from '@ribajs/core'

/**
 * Custom alt binder that ensures the alt attribute is always present on img elements
 * Falls back to empty string if value is undefined/null to maintain accessibility
 */
export class AltBinder extends Binder<string | undefined | null, HTMLElement> {
  static key = 'alt'

  routine(el: HTMLElement, value?: string | null) {
    // Always set alt attribute, even if empty
    // This is important for accessibility and SEO
    const altValue = value ?? ''
    el.setAttribute('alt', altValue)
  }
}
